/**
 * i18n Configuration
 * ===================
 * Multi-language support for admin panel
 *
 * Supported languages:
 * - uk (Ukrainian) - default
 * - ru (Russian)
 * - en (English)
 */

/* eslint-disable no-undef */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import ukTranslations from './locales/uk.json'
import ruTranslations from './locales/ru.json'
import enTranslations from './locales/en.json'

// Language detection from localStorage or default to Ukrainian
const savedLanguage = localStorage.getItem('language') || 'uk'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      uk: {
        translation: ukTranslations,
      },
      ru: {
        translation: ruTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    lng: savedLanguage, // Default language (Ukrainian)
    fallbackLng: 'uk', // Fallback to Ukrainian if translation is missing
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for now
    },
  })

// Save language preference to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng)
})

export default i18n
